import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subscription, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AdminUrlBuilder } from '../../../../../../../shared/admin/api/admin-url-builder';
import { AbstractListComponent } from '../../../../../../../shared/crud/component/list.component';
import { IPagination } from '../../../../../../../shared/crud/list/pagination.interface';
import { InventoryEditStockModal } from '../../../modals/inventory-datatable-edit/inventory-datatable-edit.component';
import { InventoryUpdateStockModal } from '../../../modals/inventory-datatable-update/inventory-datatable-update.component';

@Component({
    selector: 'inventory-list-datatable',
    templateUrl: './inventory-list-datatable.component.html',
    styleUrls: ['./inventory-list-datatable.component.scss'],
})
export class AdminInventoryListDatatableComponent
    extends AbstractListComponent
    implements OnChanges, OnInit, OnDestroy
{
    @Input() selectedCampaign!: number | null;

    modalRef: BsModalRef;
    updateEventSubscription: Subscription;
    editProductEventSubscription: Subscription;

    constructor(
        httpClient: HttpClient,
        toastrService: ToastrService,
        router: Router,
        route: ActivatedRoute,
        urlBuilder: AdminUrlBuilder,
        private modalService: BsModalService
    ) {
        super(httpClient, toastrService, router, route, urlBuilder);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        if (this.updateEventSubscription) {
            this.updateEventSubscription.unsubscribe();
        }
        if (this.editProductEventSubscription) {
            this.editProductEventSubscription.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['selectedCampaign']) {
            this.parameters.offset = 0;
            this.refreshData();
        }
    }

    refreshData() {
        if (this.selectedCampaign === null) return;

        this.parameters.conditions = { campaign: this.selectedCampaign };
        if (this.selectedCampaign === 0) {
            this.parameters.conditions = {};
        }
        this.httpClient
            .get<any>(this.buildUrl(), { params: this.parameters.toStringParams() })
            .pipe(
                map((response: any) => {
                    this.pagination = <IPagination>response;
                    return response;
                }),
                catchError((error: any) => {
                    this.toastrService.error(error.error ? error.error.message || 'Something went wrong...' : 'Error');
                    return throwError(error);
                })
            )
            .subscribe();
    }

    getResourceUrl(): string {
        return '/stock-item';
    }

    onUpdate(row): void {
        this.modalRef = this.modalService.show(InventoryUpdateStockModal, {
            initialState: {
                productName: row.name,
                currentStock: row.count,
            },
        });

        this.updateEventSubscription = this.modalRef.content.updateEvent.subscribe((result: number) => {
            if (result >= 0) {
                this.httpClient
                    .put(this.urlBuilder.buildUrl(this.getResourceUrl() + '/count-override/' + row.id), {
                        countOverride: result,
                    })
                    .subscribe(
                        (response: any) => {
                            this.modalRef.hide();
                            this.load();
                        },
                        (error: any) => {
                            this.loading = false;
                        }
                    );
            }
        });
    }

    onEdit(row): void {
        this.modalRef = this.modalService.show(InventoryEditStockModal, {
            initialState: {
                productName: row.name,
                externalId: row.externalId,
                category: row.category,
                campaignUuid: row.campaign.uuid,
                campaignLanguage: row.campaign.languageDefault,
                stockProductId: row.id,
                subcategory: row.subcategory,
                stockProducts: row.stockProducts,
            },
        });

        this.editProductEventSubscription = this.modalRef.content.onProductEdited.subscribe((result: number) => {
            this.load();
        });
    }
}
